@let s = section();
<cft-content-section titleAlignment="left" [title]="s.title" [description]="s.description" [plot]="s.subtitle">
  <div class="flex min-h-full flex-col justify-center gap-y-md">
    @if (s.video?.youtubeId; as ytId) {
      <cft-youtube-video
        class="aspect-video h-full w-full"
        style="display: block"
        width="100%"
        height="100%"
        [videoId]="ytId"
        [rounded]="true"
        [shadow]="true"
      />
    }
    @if (s.callToAction; as cta) {
      <cft-call-to-action [callToAction]="s.callToAction" />
    }
  </div>
</cft-content-section>
